// src/hooks/useChatId.ts
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export function useChatId() {
  const params = useParams<{ chatId?: string }>();
  const navigate = useNavigate();

  const [chatId, setChatId] = useState<string | null>(params.chatId ?? null);

  // URLが変わったら state 側も同期
  useEffect(() => {
    setChatId(params.chatId ?? null);
  }, [params.chatId]);

  // 新規チャット→chat_id確定時にURLを置き換える
  const commitChatIdToUrl = (id: string) => {
    setChatId(id);
    navigate(`/board/${id}`, { replace: true });
  };

  return { chatId, setChatId, commitChatIdToUrl };
}
